import axios from "axios";
import { authHeaderJson } from "../auth-header.service";


const getLeBuTree = () => {
    return axios.get(`/api/LegalEntity/orgestructureorder`, { headers: authHeaderJson() });
};
const getPartysByBookId = (bookId) => {
    return axios.get(`/api/SbBook/party/${bookId}/list`, { headers: authHeaderJson() }) 
};
const savePartysByBookId = (bookId, objPartyList) => {
    return axios.put(`/api/SbBook/party/${bookId}/list`, objPartyList, { headers: authHeaderJson() });
};
const deletePartyById = (partyId) => {
    return axios.delete(`/api/SbBook/party/${partyId}`, { headers: authHeaderJson() });
};


const getUsersByPartyId = (partyId) => {
    return axios.get(`/api/sbBook/partymemberFP/${partyId}/list`, { headers: authHeaderJson() } )
};

const getPartyUsersByBookId = (bookId) => {
    return axios.get(`/api/SbBook/sectionpartymember/${bookId}/list`, { headers: authHeaderJson() });
};




const updatePartyUserById = (item) => {
    return axios.put(`/api/SbBook/partymember/${item.id}`, item, { headers: authHeaderJson() });
};

const getPartyUserById = (bookId, id) => {
    return axios.get(`/api/SbBook/partymember/${bookId}/${id}`, { headers: authHeaderJson() });
};

const saveUsersByBookId = (bookId, partyId, objPartyList) => {
    return axios.put(`/api/SbBook/partymember/${bookId}/${partyId}/list`, objPartyList, { headers: authHeaderJson() });
};

const deletePartyUserById = (partyUserId) => {
    return axios.delete(`/api/SbBook/partymember/${partyUserId}`, { headers: authHeaderJson() });
};

const editPartyUserById = (partyUserId, roleId) => {
    return axios.delete(`/api/SbBook/partymember/${partyUserId}/${roleId}`, { headers: authHeaderJson() });
};

export {
    getPartysByBookId,
    savePartysByBookId,
    deletePartyById,
    updatePartyUserById,
    getPartyUserById,
    getLeBuTree,
    getUsersByPartyId,
    deletePartyUserById,
    editPartyUserById,
    saveUsersByBookId,
    getPartyUsersByBookId
}